import React, { useState, useEffect } from 'react';
import Header from '../components/Header';

export default function CameraPage() {
  const [imageSrc, setImageSrc] = useState('');
  const [isStreaming, setIsStreaming] = useState(true);
  const [lastImageTime, setLastImageTime] = useState(Date.now());
  const [statusMessage, setStatusMessage] = useState('');
  const [currentTime, setCurrentTime] = useState(new Date());

  // อัปเดตภาพจากกล้อง
  useEffect(() => {
    let intervalId;
    if (isStreaming) {
      intervalId = setInterval(() => {
        const timestamp = Date.now();
        const newImageUrl = `http://projecteggincubator.com/video_stream.php?t=${timestamp}`;
        setImageSrc(newImageUrl);
      }, 500);
    }
    return () => clearInterval(intervalId);
  }, [isStreaming]);

  // ตรวจสอบสถานะกล้อง
  useEffect(() => {
    const checkInterval = setInterval(() => {
      if (isStreaming && Date.now() - lastImageTime > 5000) {
        setStatusMessage('⚠️ Camera is not connected');
      } else {
        setStatusMessage('');
      }
    }, 1000);
    return () => clearInterval(checkInterval);
  }, [lastImageTime, isStreaming]);

  // อัปเดตเวลาปัจจุบันทุกวินาที
  useEffect(() => {
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timeInterval);
  }, []);

  const handleImageLoad = () => {
    setLastImageTime(Date.now());
  };

  // ฟังก์ชันจัดรูปแบบวันเวลา
  const formatDateTime = (date) => {
    return date.toLocaleString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  };

  return (
    <div className="page Camera" style={{ backgroundColor: '#FEE191', height: '100vh', padding: 0 }}>
      <Header />
      <div style={{ textAlign: 'center', paddingTop: '2rem' }}>
        <h2 style={{ marginBottom: '2rem', fontSize: '2rem', color: '#333' }}>Camera</h2>

        <div style={containerStyle}>
          {/* กล่องซ้าย - ฟักไข่ */}
          <div style={cardStyle}>
            {isStreaming ? (
              <img
                src={imageSrc}
                onLoad={handleImageLoad}
                width="320"
                height="240"
                alt="Live Camera"
                style={{ borderRadius: '8px', objectFit: 'cover', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
              />
            ) : (
              <p style={{ color: '#999' }}>Stream not started</p>
            )}

            {/* เวลาแสดงใต้ภาพ */}
            <div style={{ marginTop: '1rem', color: '#555', fontSize: '14px' }}>
              🕒 {formatDateTime(currentTime)}
            </div>

            {/* ปุ่มควบคุม */}
            <button
              onClick={() => setIsStreaming(!isStreaming)}
              style={{
                ...buttonBoxStyle,
                background: isStreaming
                  ? 'linear-gradient(to right, #ff416c, #ff4b2b)' // แดง gradient
                  : 'linear-gradient(to right, #00b09b, #96c93d)', // เขียว gradient
              }}
            >
              📷 {isStreaming ? 'หยุดสตรีม' : 'ดูตู้ฟักไข่'}
            </button>

            {statusMessage && (
              <p style={{ color: 'red', marginTop: '10px' }}>{statusMessage}</p>
            )}
          </div>

          {/* กล่องขวา - ตรวจเชื้อ */}
          <div style={cardStyle}>
            <iframe
              src=""
              width="320"
              height="240"
              frameBorder="0"
              allow="autoplay"
              title="Candling Stream"
              style={{ borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
            />
            <div style={buttonBoxStyleStatic}>สำหรับตรวจสอบเชื้อ</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ========== STYLE ==========

const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '4rem',
  flexWrap: 'wrap',
  padding: '0 2rem'
};

const cardStyle = {
  background: 'white',
  borderRadius: '16px',
  padding: '1rem',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '350px'
};

const buttonBoxStyle = {
  marginTop: '1rem',
  padding: '10px 20px',
  border: 'none',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: 'bold',
  color: '#fff',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
};

const buttonBoxStyleStatic = {
  marginTop: '1rem',
  padding: '0.5rem 1rem',
  background: '#eee',
  border: '1px solid #aaa',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'default',
  color: '#444'
};
